<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="52vw"
    @close="handleDialogClose"
  >
    <!-- 自定义菜单切换 -->
    <div class="datamenubox">
      <div
        :class="
          activeTab == 'deviceInfo' ? 'datamenuitem died' : 'datamenuitem'
        "
        @click="menuChange('deviceInfo')"
      >
        设备信息
      </div>
      <div
        :class="
          activeTab == 'deviceData' ? 'datamenuitem died' : 'datamenuitem'
        "
        @click="menuChange('deviceData')"
      >
        设备数据
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="dialog-content">
      <!-- 统一的表单容器 -->
      <el-form :model="formData" :rules="rules" ref="form" label-width="120px">
        <!-- 设备信息内容 -->
        <div v-show="activeTab == 'deviceInfo'" class="content-panel">
          <el-form-item label="设备名称" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入"
              maxlength="50"
              style="width: 16vw"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="所属企业" prop="tenantId">
            <el-select
              v-model="formData.tenantId"
              placeholder="请选择"
              style="width: 16vw"
              @change="handleTenantChange"
            >
              <el-option
                v-for="item in tenantOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属大棚" prop="greenhouseId">
            <el-select
              v-model="formData.greenhouseId"
              placeholder="请选择"
              style="width: 16vw"
              @change="handleGreenhouseChange"
            >
              <el-option
                v-for="item in greenhouseOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属场景" prop="scene">
            <el-select
              v-model="formData.scene"
              placeholder="请选择"
              style="width: 16vw"
            >
              <el-option
                v-for="item in sceneOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备位置" prop="location">
            <el-input
              v-model="formData.location"
              placeholder="手动输入"
              style="width: 16vw"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 设备数据内容 -->
        <div v-show="activeTab == 'deviceData'" class="content-panel">
          <!-- 设备数据配置区域 -->
          <div class="device-data-config">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="CBox编码" prop="cboxCode">
                  <el-select
                    v-model="formData.cboxCode"
                    placeholder="请选择CBox编码"
                    style="width: 100%"
                    @change="handleCboxCodeChange"
                    clearable
                  >
                    <el-option
                      v-for="item in cboxOptions"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="CBox设备ID" prop="cboxDeviceId">
                  <el-select
                    v-model="formData.cboxDeviceId"
                    placeholder="请选择CBox设备ID"
                    style="width: 100%"
                    @change="handleCboxDeviceChange"
                    clearable
                    :disabled="!formData.cboxCode"
                  >
                    <el-option
                      v-for="item in cboxDeviceOptions"
                      :key="item.id"
                      :label="`${item.name}`"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="CBox IP" prop="cboxIp">
                  <el-input
                    v-model="formData.cboxIp"
                    placeholder="自动获取"
                    style="width: 100%"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备参数" prop="deviceParams">
                  <el-select
                    v-model="formData.deviceParams"
                    placeholder="请选择设备参数"
                    style="width: 100%"
                    multiple
                    @change="handleDeviceParamsChange"
                    clearable
                    :disabled="!formData.cboxDeviceId"
                  >
                    <el-option
                      v-for="item in deviceParamsOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="下控地址" prop="controlUrl">
                  <el-input
                    v-model="formData.controlUrl"
                    placeholder="请输入下控地址"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 空列，保持布局 -->
              </el-col>
            </el-row>
          </div>

          <!-- 设备变量配置表格 -->
          <div class="parameter-table">
            <el-table
              :data="formData.deviceVariableList"
              border
              style="width: 100%"
            >
              <el-table-column
                label="序号"
                type="index"
                width="60"
                align="center"
              ></el-table-column>
              <el-table-column label="参数类型" width="150">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.type"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in variableTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="参数名称" width="250">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="id绑定" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.uniqueId }}</span>
                </template>
              </el-table-column>
              <el-table-column label="变量ID" width="100">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.uniqueId
                      ? scope.row.uniqueId.split("_").pop()
                      : ""
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态执行时间(S)" width="150">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.statusExecDuration"
                    placeholder="请输入"
                    type="number"
                    :controls="false"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    style="color: #2680dd"
                    @click="removeVariable(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">确定</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";

export default {
  name: "EquipmentControlDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: "deviceInfo", // 当前激活的标签页
      formData: {
        id: undefined,
        name: "", // 设备名称
        tenantId: "", // 所属企业id
        tenantName: "", // 所属企业名称
        greenhouseId: "", // 大棚编号id
        greenhouseName: "", // 大棚编号
        scene: "", // 智控场景
        location: "", // 设备位置
        cboxCode: "", // CBOX编码
        cboxDeviceId: "", // CBOX设备id
        cboxIp: "", // CBOXip
        deviceParams: [], // 设备参数（多选）
        controlUrl: "", // 下控地址
        deviceVariableList: [], // 设备变量列表
      },
      tenantOptions: [],
      greenhouseOptions: [],
      variableTypeOptions: [], // 参数类型选项
      sceneOptions: [], // 场景类型选项
      cboxData: [], // CBOX数据
      cboxOptions: [], // CBox编码选项
      cboxDeviceOptions: [], // CBox设备选项
      deviceParamsOptions: [], // 设备参数选项
      rules: {
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        tenantId: [
          { required: true, message: "请选择所属企业", trigger: "change" },
        ],
        greenhouseId: [
          { required: true, message: "请选择所属大棚", trigger: "change" },
        ],
        scene: [
          { required: true, message: "请选择所属场景", trigger: "change" },
        ],
        cboxCode: [
          { required: true, message: "请选择CBox编码", trigger: "change" },
        ],
        cboxDeviceId: [
          { required: true, message: "请选择CBox设备ID", trigger: "change" },
        ],
        cboxIp: [{ required: true, message: "请输入CBox IP", trigger: "blur" }],
        deviceParams: [
          { required: true, message: "请选择设备参数", trigger: "change" },
        ],
        controlUrl: [
          { required: true, message: "请输入下控地址", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? "编辑" : "新增";
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initDialog();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  created() {
    this.fetchTenantOptions();
    this.fetchGreenhouseOptions();
    this.fetchVariableTypeOptions();
    this.fetchSceneTypeOptions();
    this.fetchCboxData();
  },
  methods: {
    // 设备参数变化处理
    handleDeviceParamsChange(selectedParams) {
      // 保存当前所有变量的状态(包括类型)
      const currentVariables = {};
      this.formData.deviceVariableList.forEach((item) => {
        currentVariables[item.uniqueId] = {
          ...item,
          type: item.type, // 特别保存类型值
        };
      });

      // 清空变量列表
      this.formData.deviceVariableList = [];

      // 遍历选中的设备参数
      selectedParams.forEach((paramCode) => {
        // 从设备参数选项中找到对应的参数信息
        const paramInfo = this.deviceParamsOptions.find(
          (item) => item.value == paramCode
        );
        if (!paramInfo) return;

        // 生成变量序列号：CBox编码_设备ID_参数编码
        const uniqueId = `${this.formData.cboxCode}_${this.formData.cboxDeviceId}_${paramCode}`;
        // 如果这个变量之前存在，使用之前的所有状态
        if (currentVariables[uniqueId]) {
          this.formData.deviceVariableList.push({
            ...currentVariables[uniqueId],
            uniqueId,
            dataType: paramInfo.dataType,
            variableName: paramInfo.label,
          });
        } else {
          // 新变量使用默认值
          this.formData.deviceVariableList.push({
            type:
              this.variableTypeOptions.length > 0
                ? this.variableTypeOptions[0].value
                : "",
            name: paramInfo.label,
            statusExecDuration: "",
            uniqueId,
            dataType: paramInfo.dataType,
          });
        }
      });
    },
    // 菜单切换方法
    menuChange(tab) {
      this.activeTab = tab;
    },
    // 初始化弹窗
    async initDialog() {
      this.activeTab = "deviceInfo";
      if (this.isEdit && this.editData) {
        // 处理设备变量数据，将deviceVariables转换为deviceVariableList格式
        let deviceVariableList = [];
        let deviceParams = [];

        if (
          this.editData.deviceVariables &&
          Array.isArray(this.editData.deviceVariables)
        ) {
          deviceVariableList = this.editData.deviceVariables.map(
            (variable) => ({
              id: variable.id,
              type: variable.type,
              name: variable.name,
              statusExecDuration: variable.statusExecDuration,
              uniqueId: variable.uniqueId,
              dataType: variable.dataType,
              cboxVariableId: variable.cboxVariableId,
            })
          );

          // 从设备变量中提取设备参数编码
          deviceParams = this.editData.deviceVariables
            .map((variable) => {
              // 从uniqueId中提取参数编码：格式为 CBox编码_设备ID_参数编码
              const parts = variable.uniqueId
                ? variable.uniqueId.split("_")
                : [];
              return parts.length >= 3 ? parts[2] : null;
            })
            .filter((param) => param !== null);
        } else if (this.editData.deviceVariableList) {
          // 如果已经是deviceVariableList格式，直接使用
          deviceVariableList = this.editData.deviceVariableList;
          deviceParams = this.editData.deviceParams || [];
        }
        setTimeout(() => {
          this.initCboxCascadeData();
          this.formData = {
            id: this.editData.id,
            name: this.editData.name || "",
            tenantId: this.editData.tenantId || "",
            tenantName: this.editData.tenantName || "",
            greenhouseId: this.editData.greenhouseId || "",
            greenhouseName: this.editData.greenhouseName || "",
            scene: this.editData.scene || "",
            location: this.editData.location || "",
            cboxCode: this.editData.cboxCode || "",
            cboxDeviceId: this.editData.cboxDeviceId || "",
            cboxIp: this.editData.cboxIp || "",
            deviceParams,
            controlUrl: this.editData.controlUrl || "",
            deviceVariableList: deviceVariableList,
          };
        }, 1200);
      } else {
        this.resetForm();
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    // 初始化CBox级联数据（编辑模式专用）
    initCboxCascadeData() {
      if (!this.editData.cboxCode) {
        return;
      }

      // 找到选中的CBox
      const selectedCbox = this.cboxOptions.find(
        (item) => item.code == this.editData.cboxCode
      );

      if (selectedCbox) {
        // 设置设备选项
        console.log("selectedCbox", selectedCbox);
        this.cboxDeviceOptions = selectedCbox.children.map((device) => ({
          id: device.id,
          code: device.code,
          name: device.name,
          children: device.children || [],
        }));
        // 如果有设备ID，初始化设备参数选项
        if (this.editData.cboxDeviceId) {
          const selectedDevice = this.cboxDeviceOptions.find(
            (item) => item.code == this.editData.cboxDeviceId
          );
          if (selectedDevice && selectedDevice.children) {
            // 设置设备参数选项
            this.deviceParamsOptions = selectedDevice.children.map((param) => ({
              value: param.code,
              label: param.name,
              dataType: param.dataType,
            }));
          }
        }
      }
    },

    // 重置表单
    resetForm() {
      this.formData = {
        id: undefined,
        name: "",
        tenantId: "",
        tenantName: "",
        greenhouseId: "",
        greenhouseName: "",
        scene: "",
        location: "",
        cboxCode: "",
        cboxDeviceId: "",
        cboxIp: "",
        deviceParams: [],
        controlUrl: "",
        deviceVariableList: [],
      };
      // 清空级联选项
      this.cboxDeviceOptions = [];
      this.deviceParamsOptions = [];
    },
    // 获取企业列表
    async fetchTenantOptions() {
      const res = await axios.get(baseUrl + "/api/system/users");
      // 过滤出角色为企业的用户
      const agriTechUsers = res.data.filter(
        (user) =>
          user.roleCodes && user.roleCodes.split(",").includes("company_admin")
      );
      this.tenantOptions = agriTechUsers.map((item) => ({
        label: item.nickName,
        value: item.id,
      }));
    },
    // 获取大棚列表
    async fetchGreenhouseOptions() {
      const formData = new FormData();
      formData.append("enableStatus", 1);
      const greenhouseRes = await axios.post(
        baseUrl + "/api/basic/greenhouse/selection",
        formData
      );
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
    },
    // 获取参数类型列表
    async fetchVariableTypeOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/device/device-info/intel-variable-type"
        );
        this.variableTypeOptions = res.data.map((item) => ({
          label: item.value,
          value: item.key,
        }));
      } catch (error) {
        console.error("获取参数类型失败:", error);
      }
    },
    // 获取场景类型列表
    async fetchSceneTypeOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/device/device-info/scene-type"
        );
        this.sceneOptions = res.data.map((item) => ({
          label: item.value,
          value: item.key,
        }));
      } catch (error) {
        console.error("获取场景类型失败:", error);
        // 如果接口失败，使用默认选项
      }
    },
    // 获取企业下大棚列表
    async fetchGreenhouseOptionsByTenant(tenantId) {
      const formData = new FormData();
      formData.append("tenantId", tenantId);
      formData.append("enableStatus", 1);

      const greenhouseRes = await axios.post(
        baseUrl + "/api/basic/greenhouse/selection",
        formData
      );
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
    },
    // 获取cbox数据
    async fetchCboxData() {
      try {
        const apiUrl = `/gbox-iot/gbox/management/cascade/project?code=PR202504180001`;
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const res = await response.json();
        this.cboxData = res.data.tree[0].children;

        // 初始化CBox编码选项
        this.cboxOptions = this.cboxData.map((item) => ({
          code: item.code,
          name: item.name,
          ip: item.ip,
          children: item.children || [],
        }));

        console.log("cboxData", res);
      } catch (error) {
        console.error("获取CBox数据失败:", error);
        this.$message && this.$message.error("获取CBox数据失败");
      }
    },

    // CBox编码变化处理
    handleCboxCodeChange(cboxCode) {
      // 保存编辑模式下的原始数据
      const originalData = this.isEdit
        ? {
            cboxDeviceId: this.formData.cboxDeviceId,
            deviceParams: [...this.formData.deviceParams],
            deviceVariableList: [...this.formData.deviceVariableList],
            controlUrl: this.formData.controlUrl,
          }
        : {};

      // 清空下级选择
      this.formData.cboxDeviceId = "";
      this.formData.cboxIp = "";
      this.formData.deviceParams = [];
      this.formData.controlUrl = "";
      this.cboxDeviceOptions = [];
      this.deviceParamsOptions = [];

      // 清空设备变量列表
      this.formData.deviceVariableList = [];

      if (cboxCode) {
        // 找到选中的CBox
        const selectedCbox = this.cboxOptions.find(
          (item) => item.code == cboxCode
        );
        if (selectedCbox) {
          // 设置IP
          this.formData.cboxIp = selectedCbox.ip || "";

          // 设置设备选项
          this.cboxDeviceOptions = selectedCbox.children.map((device) => ({
            id: device.id,
            code: device.code,
            name: device.name,
            children: device.children || [],
          }));

          // 如果是编辑模式且CBox编码没有变化，恢复原始数据
          if (this.isEdit && cboxCode == this.editData.cboxCode) {
            this.formData.cboxDeviceId = originalData.cboxDeviceId;
            this.formData.deviceParams = originalData.deviceParams;
            this.formData.deviceVariableList = originalData.deviceVariableList;
            this.formData.controlUrl = originalData.controlUrl;

            // 如果有设备ID，需要重新设置设备参数选项
            if (this.formData.cboxDeviceId) {
              this.$nextTick(() => {
                this.handleCboxDeviceChange(this.formData.cboxDeviceId);
              });
            }
          }
        }
      }
    },

    // CBox设备变化处理
    handleCboxDeviceChange(deviceId) {
      // 保存当前设备变量列表（编辑模式下需要保留）
      const currentDeviceVariableList = this.isEdit
        ? [...this.formData.deviceVariableList]
        : [];
      const currentDeviceParams = this.isEdit
        ? [...this.formData.deviceParams]
        : [];
      const currentControlUrl = this.isEdit ? this.formData.controlUrl : "";

      // 清空设备参数和下控地址选择
      this.formData.deviceParams = [];
      this.formData.controlUrl = "";
      this.deviceParamsOptions = [];

      // 清空设备变量列表（新增模式下清空，编辑模式下保留）
      if (!this.isEdit) {
        this.formData.deviceVariableList = [];
      }

      if (deviceId) {
        // 找到选中的设备
        const selectedDevice = this.cboxDeviceOptions.find(
          (item) => item.code == deviceId
        );
        if (selectedDevice && selectedDevice.children) {
          // 设置设备参数选项（这里假设children中的项目就是设备参数）
          this.deviceParamsOptions = selectedDevice.children.map((param) => ({
            value: param.code,
            label: param.name,
            dataType: param.dataType,
          }));

          // 如果是编辑模式，恢复设备变量列表和相关数据
          if (this.isEdit) {
            this.formData.deviceVariableList = currentDeviceVariableList;
            this.formData.deviceParams = currentDeviceParams;
            this.formData.controlUrl = currentControlUrl;
          }
        }
      }
    },
    // 企业变化处理
    async handleTenantChange() {
      // 清空大棚选择
      this.formData.greenhouseId = "";
      this.formData.greenhouseName = "";

      // 获取该企业下的大棚列表
      if (this.formData.tenantId) {
        await this.fetchGreenhouseOptionsByTenant(this.formData.tenantId);
      }
    },
    // 大棚变化处理
    handleGreenhouseChange() {
      const selectedGreenhouse = this.greenhouseOptions.find(
        (item) => item.value == this.formData.greenhouseId
      );
      if (selectedGreenhouse) {
        this.formData.greenhouseName = selectedGreenhouse.label;
      }
    },
    // 删除设备变量
    removeVariable(index) {
      // 获取要删除的变量
      const removedVariable = this.formData.deviceVariableList[index];

      // 从变量列表中删除
      this.formData.deviceVariableList.splice(index, 1);

      // 更新设备参数绑定值
      this.updateDeviceParamsFromVariables();
    },

    // 根据当前变量列表更新设备参数绑定值
    updateDeviceParamsFromVariables() {
      // 从当前变量列表中提取参数编码
      const currentParams = this.formData.deviceVariableList
        .map((variable) => {
          // 从uniqueId中提取参数编码：格式为 CBox编码_设备ID_参数编码
          const parts = variable.uniqueId ? variable.uniqueId.split("_") : [];
          return parts.length >= 3 ? parts[2] : null;
        })
        .filter((param) => param !== null);

      // 更新设备参数绑定值
      this.formData.deviceParams = currentParams;
    },
    // 提交表单
    async handleSubmit() {
      try {
        await this.$refs.form.validate();

        const submitData = {
          ...this.formData,
          deviceType:"INTEL_CONTROL_DEVICE",
          tenantName:
            this.tenantOptions.find((t) => t.value == this.formData.tenantId)
              ?.label || "",
          greenhouseName:
            this.greenhouseOptions.find(
              (g) => g.value == this.formData.greenhouseId
            )?.label || "",
        };

        this.$emit("submit", submitData);
        this.dialogVisible = false;
      } catch (error) {
        if (error !== false) {
          // 表单验证失败时error为false
          console.error("表单验证失败:", error);
        }
      }
    },
    // 取消
    handleCancel() {
      this.dialogVisible = false;
    },
    // 弹窗关闭
    handleDialogClose() {
      this.resetForm();
    },
  },
};
</script>

<style scoped lang="less">
.datamenubox {
  margin: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;

  .datamenuitem {
    padding: 10px 20px;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    background-image: url("../../../assets/img/data/btn.png");
    background-size: 100% 100%;
  }

  .died {
    background-image: url("../../../assets/img/data/btned.png");
  }
}

.dialog-content {
  padding: 20px;

  .content-panel {
    min-height: 400px;
  }

  .device-data-config {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 4px;
  }

  .parameter-table {
    .add-parameter-btn {
      text-align: center;
      border-radius: 4px;
    }
  }
}
</style>
